import '../../@types';
import type Aegis from 'aegis-web-sdk';
import type { WebConfig } from 'aegis-web-sdk';
import type { PassFactory } from '../../@types/lipass';
import { loadScript } from './loader';
import { onEventEmitted } from './event';
import {isInWujie} from "./env";

declare interface Window extends globalThis.Window {
    gtag?: Gtag.Gtag;
    dataLayer: any[];
    Aegis?: Aegis;
}

declare const window: Window;

const actName = (window.$wujie?.location ?? location).pathname.match(/(?:act|cp)\/([^/]+)/)?.[1] ?? (window.$wujie?.location ?? location).host;
let pageName = (window.$wujie?.location ?? location).pathname.match(/[^/]+$/)?.[0] ?? 'index.html';
if (pageName === actName) pageName = 'index.html';

// 全局默认事件参数
const defalutEventParams: { [k: string]: string | number | boolean } = { actName, pageName };
// 设置默认的事件参数
export function setDefaultEventParams(ep: object) {
    if (ep) Object.assign(defalutEventParams, ep);
}

// 监听登录事件，获取 openid
let openid: string = '';
onEventEmitted('login', (userInfo: PassFactory.UserInfo) => {
    console.debug('[Act][ reporter ] 已登录，openid = ', userInfo.openid);
    openid = userInfo.openid;
    defalutEventParams.openid = openid;
    gtag('event', 'login_success', { event_label: '登录成功' });
});

// *********************************
// Google Analytics
// *********************************

window.dataLayer = window.dataLayer || [];
let targetId = '';

export const gtag: Gtag.Gtag = function <T extends keyof Gtag.GtagCommands>() {
    const command = arguments[0] as T; // eslint-disable-line prefer-rest-params
    if (command === 'event') {
        let [, eventName, eventParams]: [string, string, Gtag.EventParams] = arguments as any; // eslint-disable-line prefer-rest-params
        arguments[2] = eventParams = Object.assign({}, defalutEventParams, eventParams); // eslint-disable-line prefer-rest-params
        wujieReport(eventName, eventParams);
        console.debug('[reporter] 埋点上报', eventName, eventParams);
    }
    // else if (command === 'config') {
    //     let [, , config]: [string, string, Gtag.EventParams] = arguments as any; // eslint-disable-line prefer-rest-params
    //     arguments[2] = config = Object.assign({}, defalutEventParams, config); // eslint-disable-line prefer-rest-params
    //     wujieReport('PV', Object.assign({ openid }, config));
    // }
    // 谷歌埋点上报
    // eslint-disable-next-line prefer-rest-params
    if (targetId) {
        if (command === 'js' && window.dataLayer[0][0] === 'js') {
            // do nothing
            console.warn('[Google Analytics] js 事件已上报');
        } else if (command === 'config' && window.dataLayer[1][0] === 'config') {
            // do nothing
            console.warn('[Google Analytics] config 事件已执行');
        } else window.dataLayer.push(arguments); // eslint-disable-line prefer-rest-params
    }
};

const startTime = new Date().getTime();

window.addEventListener('load', () => {
    for (const script of Array.from(document.scripts)) {
        const matched = script.src?.match(/googletagmanager.*id=([^&]+)/);
        if (!matched) continue;
        targetId = matched[1];
        console.debug('[Google Analytics] 初始化谷歌埋点上报 id =', targetId);
        break;
    }
    if (!window.gtag || window.gtag !== gtag) window.gtag = gtag as any;
    if (targetId) {
        gtag('js', new Date());
        gtag('config', targetId);
    }
    // 页面加载完成默认上报 page_in 事件
    gtag('event', 'page_in', { startTime, event_label: '进入页面' });
    const loadedTime = new Date().getTime();
    gtag('event', 'page_loaded', { startTime, loadedTime, useTime: loadedTime - startTime, event_label: '页面加载完成' });
    if(isInWujie()){
        $wujie.props.reportMethod.reportPV();
    }
});

window.addEventListener('unload', () => {
    const endTime = new Date().getTime();
    gtag('event', 'page_out', { startTime, endTime, useTime: endTime - startTime, event_label: '离开页面' });
    if(isInWujie()){
        $wujie.props.reportMethod.reportPgout();
    }
});

// *********************************
// 社区综合站注入的埋点上报方法
// *********************************

const wujieReport = window.$wujie?.props.reportEvent || (() => {});
setTimeout(() => {
    wujieReport('PV', defalutEventParams);
}, 10);

// *********************************
// TAM SDK
// *********************************

let aegis: Aegis;
export async function enableTAM() {
    if (aegis) return;
    if (!window.Aegis) await loadScript('https://tam.cdn-go.cn/aegis-sdk/latest/aegis.min.js');
    if (window.Aegis) {
        // @ts-ignore
        aegis = new window.Aegis({
            id: '9GJQOSL67WeJyjQ6kw',
            reportApiSpeed: true,
            reportAssetSpeed: true,
            hostUrl: 'https://rumt-sg.com',
        } as WebConfig);
    }
}
